export default "__VITE_ASSET__CwuHVNHM__"